<script setup>
import AuthIframe from "./AuthIframe";
</script>

<template>
  <AuthIframe
    source="auth/forgot-user-id"
    use-v3-route
  />
</template>
